import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../index';

const selectState = (state: AppState) => state.dashboard;

export const selectDashboardFilters = createSelector(selectState, ({ filters }) => {
  return filters;
});
